import { SecurityGroupMember } from './security-group-member.model';

export enum SecurityGroupType {
  None = 0,
  System = 1,
  BusinessUnit = 2
}

export interface SecurityGroup {
  uId?: string;
  organizationUId?: string;
  displayName: string;
  securityGroupMembers?: SecurityGroupMember[];
  hasPermissions?: boolean;
  hasContent?: boolean;
  isHidden?: boolean;
  isSystem?: boolean;
  type?: SecurityGroupType;
  memberCount?: number;
}
